import { forwardRef } from 'react';

export const DashboardsLayout = forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    handleScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  }
>(({ children, handleScroll }, ref) => {
  // This structure is to prevent the background scroll bar from appearing over the charts crud pane
  return (
    <div
      ref={ref}
      className="relative h-screen overflow-y-scroll"
      onScroll={handleScroll}
    >
      {children}
    </div>
  );
});

DashboardsLayout.displayName = 'DashboardsLayout';
